"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("@apollo/client/link/context");
const OriginHelper_1 = __importDefault(require("@aurora/shared-utils/authentication/OriginHelper"));
const log_1 = require("@aurora/shared-utils/log");
const exenv_1 = require("exenv");
const log = (0, log_1.getLog)(module);
const originLink = (0, context_1.setContext)((_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { headers }) {
    const originHeaders = OriginHelper_1.default.getOriginHeaders();
    if (!exenv_1.canUseDOM) {
        log.trace('Setting origin headers in auth link: %O', headers);
    }
    return {
        headers: Object.assign(Object.assign({}, headers), originHeaders)
    };
}));
exports.default = originLink;
//# sourceMappingURL=originLink.js.map